import { render, staticRenderFns } from "./selectLdy.vue?vue&type=template&id=fb8c6256&scoped=true&"
import script from "./selectLdy.vue?vue&type=script&lang=js&"
export * from "./selectLdy.vue?vue&type=script&lang=js&"
import style0 from "./selectLdy.vue?vue&type=style&index=0&id=fb8c6256&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c6256",
  null
  
)

export default component.exports